import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpClientModule} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
  })
  export class LibroReclamacionVirtualService {
  
    
    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        }),
        withCredentials: true
      }
  
    constructor(private http:HttpClient) {
  
        
    }

    
    Insert(params: string):any{

        return this.http.post(environment.URL_BACKEND + 'LibroReclamacionVirtual/Insert', params.toString(),this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.errorHandl)
        )

    }




    errorHandl(error) {
      let errorMessage = '';
      if(error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      console.log(errorMessage);
      return throwError(errorMessage);
    }
     


}